import type { FC } from 'react'
import type { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next'

import CompetitorView from 'views/Competitor'
import type { CompetitorViewProps } from 'views/Competitor'

import data from 'data/competitors/[slug]'

const Competitor: FC<InferGetStaticPropsType<typeof getStaticProps>> = (props) => <CompetitorView {...props} />

export const getStaticPaths: GetStaticPaths = async () => {
  const filenames = Object.keys(data).map((path) => path.split(`/`).pop()?.toLowerCase())

  return {
    paths: filenames.map((filename) => ({ params: { slug: filename?.replace(/\.json$/, ``) } })),
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps<CompetitorViewProps> = async ({ params }) => {
  const slug = String(params?.slug) as keyof typeof data
  const dataGetter = data[slug]

  const pageConfig = {
    baseUrl: process.env.BASE_URL || ``,
    basePath: process.env.BASE_PATH || ``,
  }

  return {
    props: dataGetter(pageConfig),
  }
}

export default Competitor
